export const styles = {
    modalLoader: {
        height: '100%',
    },
};
